<template>
    <div class="container-center">

        <div style="padding:20px 0;">
            <el-button @click="tunlDialogShow=true" type="warning" class="btn-theme" size="medium" >投诉发起</el-button>
        </div>

        <div class="tunl-list-box">
            <div class="no-data-tip" v-if="tunlList.length == 0"></div>
            <div v-else class="tunl-list" v-for="li in tunlList">
                <p class="title" ><router-link :to="{name:'TunlInfo',params:{ id:li.id }}" >{{ li.title }}</router-link></p>
                <p class="date">{{ li.createDate && li.createDate.substring(0,10) }}</p>
            </div>
        </div><!-- .tunl-list-box -->


        <div class="block">
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                background
                >
            </el-pagination>
        </div>


        <el-dialog title="投诉发起" :visible.sync="tunlDialogShow" width="640px" @close="resetForm" center>

            <el-form class="invite-form" label-width="140px" ref="tunlForm" :model="tunlForm" >

                <el-form-item label="投诉标题：" prop="">
                    <el-input size="medium" v-model="tunlForm.title" clearable></el-input>
                </el-form-item>

                <el-form-item label="投诉内容：" prop="" >
                    <el-input v-model="tunlForm.content" type="textarea" :rows="3" placeholder="请输入内容">
                    </el-input>
                </el-form-item>

                <el-form-item label="附件：" prop="" >
                    <el-upload
                        class="upload-demo"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemoveTunl"
                        :action="uploadApi" :on-change="addTunlHandle"
                        multiple
                        :limit="20"
                        :file-list="tunlForm.files">
                        <el-button size="small" type="primary">上 传</el-button>
                        <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                            <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
            <el-button @click="tunlDialogShow = false">取 消</el-button>
            <el-button type="primary" @click="addTunl">提 交</el-button>
        </span>


        </el-dialog>


    </div><!-- container-center -->
</template>

<script>
import banner from '@/assets/imgs/banner_invite.png'
import util from '@/util';


export default {
    name: 'tunl-list',
    data () {
        return {

            uploadApi: `${util.baseUrl}rest/file/upload`,
            downloadApi: `${util.baseUrl}rest/file/down`,

            tunlList: [],

            tunlDialogShow: false,
            tunlForm: {
                title: '',
                content: '',
                files: []
            },

            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },

        }
    },
    methods: {

        // 上传文件格式验证
        beforeUpload(file){

            if(file.size/1024/1024 > 100) {
                this.$alert('上传附件大小请不要超过100M','文件过大！',{ type: 'error' })
                return false
            }

            if(!util.allowUpload(file.name)){
                this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                return false
            }
            return true
        },

        // 上传控件移除集中处理
        handleRemoveTunl: function(file, fileList) {
            this.tunlForm.files = this.tunlForm.files.filter(function(f){
                return f.uid !== file.uid
            });
        },

        getTunlList () {
            this.$http.post('rest/api/complaintCon/getComplaintList',
                Object.assign(
                    {
                        pageNum: this.pager.pageNum,
                        pageSize: this.pager.pageSize,
                        stockId: this.$root.stockId
                    },
                    // this.form
                )
            ).then((res)=>{
                if(res.data.result) {
                    this.tunlList = res.data.value.list;
                    this.pager.total = res.data.value.count;
                    this.pager.pageNum = res.data.value.pageNo;
                }
            })
        },

        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getTunlList();
        },

        addTunl() {

            if(!this.tunlForm.title) { this.$message({message: '请输入标题', type: 'error'}); return ;}
            if(!this.tunlForm.content) { this.$message({message: '请输入内容', type: 'error'}); return ;}

            var data = {
                supplierStockId: this.$root.stockId,
            }

            Object.assign(
                data,
                this.tunlForm
            )

            this.$http.post('rest/api/complaintCon/addComplaint', data).then((res)=>{
                if(res.data.result) {
                    this.$message({message:'发起成功', type:'success'})
                    this.getTunlList()
                } else {
                    this.$message({message:'操作失败 请联系管理员', type:'error'})
                }
                this.tunlDialogShow = false
            })
        },

        addTunlHandle: function(file) {
            // if(file.status=='success'){
                this.tunlForm.files = this.tunlForm.files.concat(__getBaseFiles__(file))
            // }
        },

        resetForm() {
            this.tunlForm = {
                title: '',
                content: '',
                files: []
            }
        },


    },
    created(){
        this.$root.navs = [{name:'投诉通道',path:'/tunlList'}];
        this.$root.headImage.src = banner;
    },
    mounted() {
        this.getTunlList()
    }
}

function __getBaseFiles__(file){

    // var F = file.response.basefiles[0],
    var F = file.basefiles[0],
        f = {}

    // f.bizTableName = F.biztablename
    // f.bizTablePkName = F.biztablepkname
    // f.bizTablePkValue = F.biztablepkvalue
    // f.fid = F.fid
    // f.fileCatagoryId = F.filecatagoryid
    // f.fileDesc = F.filedesc
    f.fileName = F.filename
    f.fileOldName = F.fileoldname
    f.filePath = F.filepath
    f.fileSize = F.filesize
    f.fileType = F.filetype
    f.sort = F.sort
    f.name = F.fileoldname

    return f

    // let f = file.response.basefiles[0]
    // file.fileOldName = f.fileoldname
    // file.fileName = f.filename
    // file.filePath = f.filepath
    // file.fileSize = f.filesize
    // file.fileType = f.filetype
    // file.sort = f.sort
    // return file
}

</script>

<style scoped lang="postcss">
@import '../../../assets/common.css';

.clearfix:after {display: table;content: " ";clear: both;}

.tunl-list {width: 100%;height: 48px;border-bottom: 1px solid #E4E5E4;}
.tunl-list > p {font-size: 16px;margin:0;line-height: 48px;}
.tunl-list > p.title {float: left;width: 1000px;font-weight: bold;}
.tunl-list > p.title a {color: #000;text-decoration: none;}
.tunl-list > p.title a:hover {color: var(--cMain);}
.tunl-list .date {float: right;}


</style>



// WEBPACK FOOTER //
// src/pages/dsp/tunl/TunlList.vue